var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('PageHeader',{attrs:{"main-header":_vm.$t('common.not-found'),"main-header-color":"grey","main-header-text-color":"white--text"}}),_c('div',{staticClass:"d-flex justify-center"},[_c('v-btn',{attrs:{"text":"","large":"","color":"primary","to":"/"}},[_vm._v(_vm._s(_vm.$t('common.back-to-home')))])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }